<template>
  <div class="home">
    <main role="main" class="ml-sm-auto col-xl-10 px-4">
    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <h1 class="h2"><a class="h6 mr-3" @click="goBack"><i class="fa fa-chevron-left"></i> retour</a>Historique de prise en charge</h1>
    </div>
    <div class="row">
        <div class="col mt-4 mt-xl-0 order-1 order-xl-0">
          <div class="row mb-2">
            <div class="col-2">
              <button class="btn btn-success btn-sm" @click="resetEditor">Creer</button>
            </div>
            <div class="col text-center" v-if="pec != null">
              {{pec.client_nom}} {{pec.client_prenom}} - {{pec.client_tel}} - Dossier N°{{pec.num_dossier}}
              <br><a target="_blank" :href="'https://suivi.macinstore.fr/'+pec.suivi">suivi.macinstore.fr/{{pec.suivi}}</a>
            </div>
            <div class="col-3 text-right" v-if="pec != null">
              <button class="btn btn-primary btn-sm" @click="pdfRow()"><i class="fa fa-file-pdf"></i></button>&nbsp;

              <button v-show="pec.hiboutik_client_id == 0" class="btn btn-primary btn-sm text-nowrap" @click="add_hiboutik_client">Ajouter dans Hiboutik</button>
              <div class="text-nowrap" v-show="pec.hiboutik_client_id > 0"><i class="fa fa-check text-success"></i> <a @click="goToHiboutikClient" href="#">Présent dans Hiboutik</a></div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <MyVuetable ref="vuetable" @detailsRow="detailsRow" :url="'pec_histos/'+id" queryString="" :fields="fields" :sortOrder="sortOrder"></MyVuetable>
            </div>
          </div>
          <div class="row" v-if="currentNote != null">
            <div class="col">
              <div class="">
                <h5>Note</h5>
                <div class="border p-2" v-html="currentNote"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-xl-4 border order-xl-12 order-0">
          <PecHistoryEditor :id="statusId" :pec_id="id" @onNewAdded="onAddDelete" @onUpdate="onUpdate" @onDelete="onAddDelete"></PecHistoryEditor>
        </div>
    </div>
    <div ref="clients_redirect"  style="display:none;"></div>
    </main>
  </div>
</template>

<script>
/* global $ */
import MyVuetable from '@/components/MyVuetable'
import PecHistoryEditor from '@/components/PecHistoryEditor'
import { getPec,checkHiboutikClient,addHiboutikClient } from '@/api/crm-api.js'

export default {
  components: {
    MyVuetable,
    PecHistoryEditor
  },
  props: {
    id: [String, Number],
    statusId: [String, Number]
  },
  data () {
    return {
      currentNote: null,
      pec: null,
      fields: [
        {
          name: 'status',
          sortField: 'status',
          title: 'Status'
        },
        {
          name: 'note',
          sortField: 'note',
          title: 'Note',
          callback: (value) => {
            return (value.length > 70 ? (value.substring(0,67)+'...') : value).replace(/\r\n/g,'<br>')
          }
        },
        {
          name: 'begin_date',
          sortField: 'begin_date',
          title: 'Date',
          callback : this.formatDate
        },
        {
          name: 'user',
          sortField: 'user',
          title: 'Collaborateur'
        }
        ,'__slot:details'
        // ,'__slot:actions'
      ],
      sortOrder: [
        {
          field: 'begin_date',
          direction: 'desc'
        }
      ]
    }
  },
  computed: {
    idInt: function () {
      if(!isNaN(parseInt(this.id))) {
        return parseInt(this.id)
      }

      return null
    },
  },
  methods: {
    formatDate(value) {
      return this.$date(value,'DD/MM/YYYY HH:mm:ss')
    },
    goBack() {
      this.$router.go(-1)
    },
    resetEditor(){
      this.$router.replace( { name:'PecHistory',params: { id: this.id }}).catch(() => {})
    },
    detailsRow(rowData) {
      this.$router.replace( { name:'PecHistory',params: { id: this.id, statusId: rowData.id.toString() }}).catch(() => {})
    },
    onAddDelete(){
      this.$refs.vuetable.refresh()
      this.resetEditor()
    },
    onUpdate(){
      this.$refs.vuetable.refresh()
    },
    goToHiboutikClient () {
      //Open window to hiboutik client
      let client_id =  this.pec.hiboutik_client_id
      $(this.$refs.clients_redirect).html('<form name="client-'+client_id+'-redirect" action="https://macinstore.hiboutik.com/" target="client-'+client_id+'" method="post" style="display:none;"><input type="hidden" name="show_tab" value="clients" /><input type="hidden" name="mon_client_affiche" value="'+client_id+'"></form>');
      document.forms['client-'+client_id+'-redirect'].submit()
    },
    add_hiboutik_client () {
      addHiboutikClient(this.pec).then((response) => {
        checkHiboutikClient(this.data.client_mail).then((response) => {
            this.pec.hiboutik_client_id = response.data
        }).catch(() => {})
        
        this.$store.commit('addMessage',{ text:response.data, status:'success' })
      })
      .catch((error) => {
        this.$store.commit('addMessage',{ text:'Une erreur s\'est produite: <br>'+error.toString(), status:'danger' })
      })
    },
    pdfRow() {
      window.open('https://www.macinstore.fr/crm-api/api/pdf/'+this.id, '_blank');
    },
  },
  mounted () {
    getPec(this.id).then((response) => {
          this.pec = { ...response.data, hiboutik_client_id: null }
          checkHiboutikClient(response.data.client_mail).then((response2) => {
              this.pec.hiboutik_client_id = response2.data
            }).catch(() => {})
        })
  }
}
</script>
